import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import { addressQualification } from "../../../../shared/hooks/useFetchCompleteAddress";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { getFailureCount, incrementFailureCount, resetFailureCount } from "../../Utils/failuretracking";
import DwLogutil from "../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";

type TransferPanelState = {
  isAccessible: boolean;
  summaryValue: string;
};

type TransferStepsState = {
  [panelId: string]: TransferPanelState;
}; 

type addressQualifucationInitialStateType = {
  data: any;
  loading: boolean;
  error: any;
  networkType: any;
  customAddressQualificationLoader: boolean,
  moversData: any,
  moversLoading: boolean,
  moversError: any,
  moversNetworkType:any,
  selectedMoversAddress: any,
  modalOpenerForMovers: any,
  lastCheckedAddressId: string | null,
  lastModalTypeForAddress: string,
  moveCost: string,
  transferStepsState: TransferStepsState,
};
const initialState: addressQualifucationInitialStateType = {
  data: null,
  loading: false,
  error: null,
  networkType: null,

  moversData: null,
  moversLoading: false,
  moversError: null,
  moversNetworkType: null,
  selectedMoversAddress: null,
  lastCheckedAddressId: null,
  lastModalTypeForAddress: "",
  
  customAddressQualificationLoader: false,
  modalOpenerForMovers: null,
  moveCost: "",
  transferStepsState: {
    panel1: {
      isAccessible: true,
      summaryValue: "",
    },
    panel2: {
      isAccessible: false,
      summaryValue: "",
    },
    panel3: {
      isAccessible: false,
      summaryValue: "",
    },
    panel4: {
      isAccessible: false,
      summaryValue: "",
    },
  },
};

export const getAddressQualification = createAsyncThunk(
  "get/address/qualification",
  async (payload: any,{ rejectWithValue }) => {
    const failCount = getFailureCount();
    if (failCount >= 2) {
      return rejectWithValue('Blocked after 2 failures');
    }
    try {
      const user = payload?.user ?? payload;
      const serviceAdd = user?.addresses?.find(
        (addr: any) => addr?.addressType === "ServiceAddress"
      );
      const reduxStore = store.getState();
      const headers = payload?.headers ?? reduxStore?.brightspeedToken?.headers;
      if (
        serviceAdd &&
        serviceAdd?.street &&
        serviceAdd?.city &&
        serviceAdd?.state &&
        serviceAdd?.addressId 
        && (!serviceAdd?.addressId?.toLowerCase()?.includes("ban")) 
      ) {
        let url=API_URLS?.addressQualificationURL;
        const addressQualificationResponse = await addressQualification(
          {
            "": `${url}?addressId=${serviceAdd?.addressId}&serviceInstanceId=${user?.serviceInstanceId || ""}&existingUser=EC`,
          },
          headers
        );
        if (
          addressQualificationResponse?.status === 200 
          // addressQualificationRes?.data && 
          // addressQualificationResponse?.data?.status !== 500 
          // && addressQualificationRes?.data?.entity
        ) {
          const addressQualificationRes = addressQualificationResponse?.data?.data
            ? addressQualificationResponse?.data
                    : addressQualificationResponse  

          if(addressQualificationRes?.data?.entity?.instantInternet === true)
          {
            DwLogutil({stepName:"user with instantInternet logged in"})        
          }
          if (addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]?.cpeDetails?.wifi6Router) {
            DwLogutil({ stepName: "user has wifi6 router" })
          }
          if (addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]?.cpeDetails?.wifi7Router) {
            DwLogutil({ stepName: "user has wifi7 router" })
          }
          resetFailureCount();
          return {
            addressQualification: addressQualificationRes?.data,
          };
        } else {
          
          throw new Error("Something went wrong with address qualification");
        }
      } else {
        throw new Error("Invalid user service address");
      }
    } catch (error:any) {
      const newCount = incrementFailureCount();
       DwLogutil({stepName:` addressqualification failed ${newCount} time(s) `,error:`${error.message}`})
      return rejectWithValue(`API call failed ${newCount} time(s): ${error.message}`);
    }
  }
);

export const getAddressQualificationMovers = createAsyncThunk(
  "get/address/qualification/movers",
  async (selectedAddress: any, { rejectWithValue }) => {
    const failCount = getFailureCount();

    if (failCount >= 2) {
      return rejectWithValue("Blocked after 2 failures");
    }

    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;

      if (selectedAddress?.fullAddress) {
        const url = API_URLS?.addressQualificationURL;

        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.movers_address_qualification_triggered})

        const addressQualificationResponse = await addressQualification(
          {
            "": `${url}?addressLine1=${selectedAddress?.fullAddress}&channel=web-acm`,
          },
          headers
        );

        if (addressQualificationResponse?.status === 200) {
          DwLogutil({ stepName: EC_DW_LOGGING_STEPS.movers_address_qualification_success})
          const addressQualificationRes = addressQualificationResponse?.data?.data
            ? addressQualificationResponse?.data
            : addressQualificationResponse;

          if (addressQualificationRes?.data?.entity?.instantInternet === true) {
            DwLogutil({ stepName: "user with instantInternet logged in" });
          }

          if (
            addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]
              ?.cpeDetails?.wifi6Router
          ) {
            DwLogutil({ stepName: "user has wifi6 router" });
          }

          if (
            addressQualificationRes?.data?.entity?.sqeDerivedValues?.[0]
              ?.cpeDetails?.wifi7Router
          ) {
            DwLogutil({ stepName: "user has wifi7 router" });
          }

          resetFailureCount();

          return {
            moversAddressQualification: addressQualificationRes?.data,
          };
        } else {
          DwLogutil({ stepName: EC_DW_LOGGING_STEPS.movers_address_qualification_failed})
          throw new Error("Something went wrong with movers address qualification");
        }
      } else {
        DwLogutil({ stepName: EC_DW_LOGGING_STEPS.movers_address_qualification_failed})
        throw new Error("Invalid movers service address");
      }
    } catch (error: any) {
      const newCount = incrementFailureCount();
      DwLogutil({ stepName: EC_DW_LOGGING_STEPS.movers_address_qualification_failed})
      DwLogutil({
        stepName: `addressqualification failed ${newCount} time(s)`,
        error: `${error.message}`,
      });
      return rejectWithValue(`API call failed ${newCount} time(s): ${error.message}`);
    }
  }
);

const addressQualificationSlice = createSlice({
  name: "address/qualification",
  initialState,
  reducers: {
    clearAddressQualificationState: (state) => {
      state.data = null;
      state.error = null;
      state.loading = false;
      state.networkType = null;
    },

    clearMoversAddressQualificationState: (state) => {
      state.moversData = null;
      state.moversError = null;
      state.moversLoading = false;
      state.moversNetworkType = null;
    },
    addressQualificationSliceSetInitialState: () => initialState,
    updateAddressQualificationSlice: (state, action) => {
      state.data = action.payload;
      if (action.payload?.addressQualification?.entity?.networkType) {
        state.networkType =
          action.payload?.addressQualification?.entity?.networkType;
      }
    },

    updateMoversAddressQualificationSlice: (state, action) => {
      state.moversData = action.payload;
      if (action.payload?.moversAddressQualification?.entity?.networkType) {
        state.moversNetworkType =
          action.payload?.moversAddressQualification?.entity?.networkType;
      }
    },

    setAddressQualificationLoader: (state, action) => {
      state.customAddressQualificationLoader = action.payload;
    },
    setMoversSelectedAddress: (state, action) => {
      state.selectedMoversAddress = action.payload;
    },
    setLastCheckedAddressId: (state, action) => {
      state.lastCheckedAddressId = action.payload;
    },
    setLastModalTypeForAddress: (state, action) => {
      state.lastModalTypeForAddress = action.payload;
    },
    setModalOpenerForMovers: (state, action) => {
      state.modalOpenerForMovers = action.payload;
    },
    setTransferStepsState: (state, action) => {
      state.transferStepsState = {
        ...state.transferStepsState,
        ...action.payload,
      };
    },
    resetTransferStepsState: (state) => {
      state.transferStepsState = initialState.transferStepsState;
    },
    setMoveCost: (state, action) => {
      state.moveCost = action.payload;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(getAddressQualification.pending, (state) => {
        state.loading = true;
    });
    builder.addCase(getAddressQualification.fulfilled, (state, action) => {
        state.data = action.payload;
        state.networkType =
          action.payload?.addressQualification?.entity?.networkType;
        state.loading = false;
        state.error = null;
    });
    builder.addCase(getAddressQualification.rejected, (state, action) => {
        state.data = null;
        state.loading = false;
        state.error = action.payload || action.error;
      })

      .addCase(getAddressQualificationMovers.pending, (state) => {
        state.moversLoading = true;
        state.moversError = null;
      })
      .addCase(getAddressQualificationMovers.fulfilled, (state, action) => {
        state.moversData = action.payload;
        state.moversNetworkType =
          action.payload?.moversAddressQualification?.entity?.networkType;
        state.moversLoading = false;
        state.moversError = null;
      })
      .addCase(getAddressQualificationMovers.rejected, (state, action) => {
        state.moversData = null;
        state.moversLoading = false;
        state.moversError = action.payload || action.error;
      });

    builder.addCase(PURGE, () => {
      return initialState;
    });

  },
});

export const {
  clearAddressQualificationState,
  clearMoversAddressQualificationState,
  addressQualificationSliceSetInitialState,
  updateAddressQualificationSlice,
  updateMoversAddressQualificationSlice,
  setAddressQualificationLoader,
  setMoversSelectedAddress,
  setLastCheckedAddressId,
  setLastModalTypeForAddress,
  setModalOpenerForMovers,
  setTransferStepsState,
  resetTransferStepsState,
  setMoveCost,
} = addressQualificationSlice.actions;
export default addressQualificationSlice.reducer;